import { PageHeader } from '@/components/ui/PageHeader'
import { useMemo } from 'react'
import { ProjectsBreadcrumbs } from '../Projects/ProjectsBreadcrumbs'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Button } from '@/components/shadcn/button'
import { PlatformAgentSkillsFilters } from '../Platform/PlatformAgentSkillsTable/PlatformAgentSkillsFilters'
import { skillColumns } from '../Platform/PlatformAgentSkillsTable/platformAgentSkillsTableColumns'
import { SkillForm } from '../Platform/Forms/SkillForm'

export function ProjectAgentSkillsPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<ProjectsBreadcrumbs title="Agent Skills" />} />
      <ProjectAgentSkillsPageContent />
    </>
  )
}

function ProjectAgentSkillsPageContent() {
  const { getSkillApiGetSkills } = useRestClient()
  const { data: skills } = getSkillApiGetSkills.useSuspenseQuery(undefined)
  const sortedSkills = useMemo(
    () => [...skills].sort((a, b) => (a.name || '').localeCompare(b.name || '')),
    [skills]
  )

  return (
    <TablePageContainer>
      <DataTable
        title="Manage Agent Skills"
        columns={skillColumns}
        data={sortedSkills}
        filters={(table) => <PlatformAgentSkillsFilters table={table} />}
        action={
          <SkillForm
            sheetTitle="New skill"
            sheetDescription="Create a reusable agent skill definition."
            sheetTrigger={
              <Button size="sm" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add skill
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
